import styled from 'styled-components'

import Card from '../../../components/Card'
import ActionButton from '../../../components/ActionButton'

export const Container = styled.div<{ $background: string }>`
  background-image: url(${(props) => props.$background});
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 1.6rem;
`

export const CardWrapper = styled(Card)``

export const Title = styled.h5`
  ${({ theme }) => theme.textStyles.H5};
  margin-bottom: 3.2rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.nightRider};
`

export const HomeButton = styled(ActionButton)``
